import React, {useCallback} from 'react';
import {Stack} from '@mui/material';
import {useSession} from '../../firebase/UserProvider';
import useYDocStore from '../../stores/useYDocStore';
import {addComment, buildThreadId} from '../prosemirror-editor/yMaps/commentsYMap';
import ListOfCommentsYjs from './ListOfCommentsYjs';
import MessageComposer from '../MessageComposer';

const CommentsSection = ({props}) => {
    const {fullHeight, autoFocus, elementName, elementId} = props || {};
    const {user} = useSession();
    const ydoc = useYDocStore((s) => s.ydoc);
    const yComments = useYDocStore((s) => s.yComments);

    const handleSubmitRich = useCallback((json) => {
        if (!elementName || !elementId || !ydoc || !yComments) return;
        try {
            const threadId = buildThreadId(elementName, elementId);
            addComment(ydoc, yComments, threadId, {
                content: json,
                contentType: 'prosemirror',
                publishedDatetime: Date.now(),
                userId: user.uid,
                userDisplayName: user.displayName,
            });
        } catch (e) {
            console.error('Failed to send comment:', e);
        }
    }, [elementName, elementId, ydoc, yComments, user]);

    return (
        <Stack height={fullHeight ? '100%' : 'auto'} flex={fullHeight ? 1 : 'none'} overflow={'auto'}>
            <ListOfCommentsYjs props={props}/>
            <MessageComposer
                onSubmitRich={handleSubmitRich}
                placeholder="Type a comment…"
                submitLabel="Comment"
                autoFocus={autoFocus}
                fullHeight={fullHeight}
            />
        </Stack>
    );
};

export default CommentsSection;
